import { render, staticRenderFns } from "./user-collection.vue?vue&type=template&id=26ae7f7f&scoped=true&"
import script from "./user-collection.vue?vue&type=script&lang=js&"
export * from "./user-collection.vue?vue&type=script&lang=js&"
import style0 from "./user-collection.vue?vue&type=style&index=0&id=26ae7f7f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ae7f7f",
  null
  
)

export default component.exports